import React, { Fragment } from "react";
import {
    renderField,
    renderSelectCustom,
    renderFieldCheck,
    renderSelectField2,
    renderFieldDPI,
} from "../../Utils/renderField/renderField";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { validate, validators } from "validate-redux-form";
import { connect } from "react-redux";
import trim from "lodash/trim";
import validarNit from "validar-nit-gt";
import { api } from "api";
import Swal from "sweetalert2";

export const isEmpty = (value) =>
    value === undefined || value === null || value === "";
export function NIT(value) {
    if (!isEmpty(value)) {
        value = trim(value.toUpperCase());
        return value !== "C/F"
            ? validarNit(value)
                ? null
                : "Escriba un nit válido"
            : null;
    }
    return null;
}


const cuiIsValid = (cui) => {
    if (!cui) {
      return true;
    }

    cui = cui.toString();

    var cuiRegExp = /^[0-9]{4}\s?[0-9]{5}\s?[0-9]{4}$/;
    if (!cuiRegExp.test(cui)) {
      return false;
    }

    cui = cui.trim();
    cui = cui.replace(/\s/, "");
    cui = cui.replace(" ", "");
    var depto = parseInt(cui.substring(9, 11), 10);
    var muni = parseInt(cui.substring(11, 13));
    var numero = cui.substring(0, 8);
    var verificador = parseInt(cui.substring(8, 9));
    let munisPorDepto = [ 17, 8, 16, 16, 13, 14, 19, 8, 24, 21, 9, 30, 32, 21, 8, 17, 14, 5, 11, 11, 7, 17 ]
    if (depto === 0 || muni === 0) {
      return false;
    }
    if (depto > munisPorDepto.length) {
      return false;
    }
    if (muni > munisPorDepto[depto - 1]) {
      return false;
    }
    var total = 0;
    for (var i = 0; i < numero.length; i++) {
      total += numero[i] * (i + 2);
    }
    var modulo = total % 11;
    return modulo === verificador;
  };

export function DPI(value) {
    if (!isEmpty(value)) {
        value = trim(value.toUpperCase());
        return value !== "C/F"
            ? cuiIsValid(value)
                ? null
                : "Escriba un dpi válido"
            : null;
    }
    return null
}

const required = (value) => (value ? undefined : "Campo requerido.");
const validaNoEspacios = (value) => value && value.indexOf(" ") >= 0 ? "No se permiten espacios" : undefined;

class FrmBillingInformation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_rental: false,
            tipo_documento: "",
            data_Paciente: {},
            initValueOptionMap: {
                NIT: "",
                CUI: "",
                EXT: "",
                CF: "C/F",
            },
            valueOptionMap: {
                NIT: "",
                CUI: "",
                EXT: "",
                CF: "C/F",
            },
        };
    }

    componentDidMount() {
        api.get(`patients/${this.props.patientID}`)
            .catch((error) => {
                Swal(
                    "Error",
                    error.detail ||
                    "Ha ocurrido un error, por favor vuelva a intentar.",
                    "error"
                );
            })
            .then((data) => {
                this.setState({
                    data_Paciente: data,
                    valueOptionMap: {
                        NIT: data.nit || "",
                        CUI: data.dpi || "",
                        EXT: "",
                        CF: "C/F",
                    },
                });
            });
    }

    render() {
        const {
            show_fields,
            use_city,
            nit,
            handleSubmit,
            validateNit,
            validateDirection,
            name,
            total_pagar,
            changeFieldFormBillingInformation,
            setDataName,
        } = this.props;

        let optionsDocumentos = [
            { value: "NIT", label: "NIT", id: "NIT" },
            { value: "CUI", label: "CUI", id: "CUI" },
            { value: "EXT", label: "EXT", id: "EXT" },
        ];

        if (total_pagar < 2500) {
            optionsDocumentos = [
                ...optionsDocumentos,
                { value: "CF", label: "CF", id: "CF" },
            ];
        }

        const firstNameFieldValidators = name ? [] : [required];

        return (
            <form onSubmit={handleSubmit} id="billing_information">
                <div className="px-md-5 pt-3 d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <div className="radio">
                        <label className="radio-inline mr-5 d-flex align-items-center">
                            <Field
                                name="option"
                                component={renderField}
                                type="radio"
                                value={"a"}
                                inputId="firstFocus"
                                onChange={(e) => {
                                    changeFieldFormBillingInformation(
                                        "tipo_documento",
                                        ""
                                    );
                                    changeFieldFormBillingInformation(
                                        "name",
                                        ""
                                    );
                                    changeFieldFormBillingInformation(
                                        "nit",
                                        ""
                                    );
                                    changeFieldFormBillingInformation(
                                        "tipo_documdocumento_pacienteento",
                                        ""
                                    );
                                }}
                            />
                            &nbsp;Facturar con datos del paciente
                        </label>
                    </div>
                    <div className="radio">
                        <label className="radio-inline mr-5 d-flex align-items-center">
                            <Field
                                name="option"
                                component={renderField}
                                type="radio"
                                value={"b"}
                                onChange={(e) => {
                                    changeFieldFormBillingInformation(
                                        "tipo_documento",
                                        ""
                                    );
                                    changeFieldFormBillingInformation(
                                        "name",
                                        ""
                                    );
                                    changeFieldFormBillingInformation(
                                        "nit",
                                        ""
                                    );
                                    changeFieldFormBillingInformation(
                                        "tipo_documdocumento_pacienteento",
                                        ""
                                    );
                                }}
                            />
                            &nbsp;Ingresar nuevos datos
                        </label>
                    </div>
                    {/*<div className="radio">
                        <label className="radio-inline mr-5 d-flex align-items-center">
                            <Field name="option" component={renderField} type="radio" value={"c"}/>
                            &nbsp;CF
                        </label>
                    </div>*/}
                </div>

                {!show_fields && (
                    <div className="d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center ">
                        <div className="m-2">
                            <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                <label htmlFor="nit" className="m-0">
                                    Tipo documento
                                </label>
                            </div>
                            <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                <Field
                                    name="tipo_documento"
                                    component={renderSelectField2}
                                    type="text"
                                    validate={[required, validaNoEspacios]}
                                    className="form-control w-75"
                                    options={optionsDocumentos}
                                    item_vacio={true}
                                    disabled={false}
                                    onChange={(e) => {
                                        if (e.target.value == "EXT") {
                                            changeFieldFormBillingInformation(
                                                "documento_paciente",
                                                ""
                                            );
                                        } else {
                                            changeFieldFormBillingInformation(
                                                "documento_paciente",
                                                this.state.valueOptionMap[
                                                e.target.value
                                                ]
                                            );
                                        }                                        

                                        this.setState({
                                            tipo_documento: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                            <div className="m-2">
                                <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                    <label htmlFor="name" className="m-0">
                                        {this.state.tipo_documento}
                                        &nbsp;
                                    </label>
                                </div>
                                <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                    <Field
                                        name="documento_paciente"
                                        component={renderField}
                                        validate={[required, validaNoEspacios]}
                                        type="text"
                                        className="form-control w-75"
                                        // input={this.state.tipo_documento != "EXT" ? {value:this.state.valueOptionMap[this.state.tipo_documento]} : {}}
                                        disabled={
                                            this.state.tipo_documento != "EXT" || this.state.tipo_documento == ""
                                        }
                                    />
                                </div>
                            </div>
                    </div>
                )}
                {show_fields && (
                    <React.Fragment>
                        <div className="d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                            <div className="m-2">
                                <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                    <label htmlFor="nit" className="m-0">
                                        Tipo documento
                                    </label>
                                </div>
                                <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                    <Field
                                        name="tipo_documento"
                                        component={renderSelectField2}
                                        type="text"
                                        className="form-control w-75"
                                        validate={[required, validaNoEspacios]}
                                        options={optionsDocumentos}
                                        item_vacio={true}
                                        disabled={false}
                                        onChange={(e) => {
                                            if (e.target.value == "EXT") {
                                                changeFieldFormBillingInformation(
                                                    "nit",
                                                    ""
                                                );
                                            } else {
                                                changeFieldFormBillingInformation(
                                                    "nit",
                                                    this.state.initValueOptionMap[
                                                    e.target.value
                                                    ]
                                                );
                                                changeFieldFormBillingInformation(
                                                    "name",
                                                    "",
                                                )
                                            }
                                            this.setState({
                                                tipo_documento: e.target.value,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="m-2">
                                {
                                this.state.tipo_documento != "NIT" &&
                                this.state.tipo_documento != "CUI" &&
                                // this.state.tipo_documento != "" &&
                                    (
                                        <React.Fragment>
                                            <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                                <label
                                                    htmlFor="nit"
                                                    className="m-0"
                                                >
                                                    {this.state.tipo_documento != "" && (this.state.tipo_documento)}
                                                    &nbsp;
                                                </label>
                                            </div>
                                            <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                                <Field
                                                    name="nit"
                                                    component={renderField}
                                                    type="text"
                                                    validate={[required, validaNoEspacios]}
                                                    disabled={ this.state.tipo_documento == "CF" || this.state.tipo_documento == ""}
                                                    className="form-control w-75"
                                                />
                                            </div>
                                        </React.Fragment>
                                    )}
                                {this.state.tipo_documento == "NIT" && (
                                    <React.Fragment>
                                        <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                            <label
                                                htmlFor="nit"
                                                className="m-0"
                                            >
                                                Nit
                                            </label>
                                        </div>
                                        <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                            <Field
                                                name="nit"
                                                component={renderField}
                                                type="text"
                                                className="form-control w-75"
                                                validate={NIT}
                                                onBlurs={validateNit}
                                                onKeyDownEnter={validateNit}
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                                {this.state.tipo_documento == "CUI" && (
                                    <React.Fragment>
                                        <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                            <label
                                                htmlFor="nit"
                                                className="m-0"
                                            >
                                                CUI
                                            </label>
                                        </div>
                                        <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                        <Field
                                            name="nit"
                                            component={renderFieldDPI}
                                            type="number"
                                            className="form-control"
                                            validate={DPI}
                                            onBlurs={true}
                                            onKeyDownEnter={setDataName}
                                        />
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                            <div className="m-2 px-5">
                                <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                    <label htmlFor="name" className="m-0">
                                        Nombre
                                    </label>
                                </div>
                                    <Field
                                        name="name"
                                        validate={
                                            this.state.tipo_documento != "CF" &&
                                            this.state.tipo_documento != "EXT" ?
                                            []: [required, validaNoEspacios]}
                                        disabled={
                                            this.state.tipo_documento != "CF" &&
                                            this.state.tipo_documento != "EXT"
                                            // && this.state.tipo_documento != "CUI"
                                        }
                                        component={renderField}
                                        addClass="form-control w-100"
                                        type="text"
                                    />
                                </div>
                    </React.Fragment>
                )}

                <div className="px-md-5 pt-3 d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <div className="radio">
                        <label className="radio-inline mr-5 d-flex align-items-center">
                            <Field
                                name="option_direction"
                                component={renderField}
                                type="radio"
                                value={"a"}
                                inputId="secondFocus"
                                onChange={(e) => {
                                    validateDirection(nit);
                                }}
                            />
                            &nbsp;Facturar con dirección del comprador
                        </label>                    
                    </div>
                    <div className="radio">
                        <label className="radio-inline mr-5 d-flex align-items-center">
                            <Field
                                name="option_direction"
                                component={renderField}
                                type="radio"
                                value={"b"}                                
                                onChange={(e) => {                                    
                                    changeFieldFormBillingInformation(
                                        "direccion_comprador",
                                        "CIUDAD"
                                    );
                                }}
                            />
                            &nbsp;Facturar con dirección CIUDAD
                        </label>                    
                    </div>                    
                </div>
                
                <div className="m-2 px-5">
                    <div
                        className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="direction" className="m-0">
                            Dirección del comprador
                        </label>
                    </div>
                    <Field
                        name="direccion_comprador"
                        
                        placeholder="Ingrese la dirección de facturación"
                        //validate={this.state.direction != "" ? []: [required]}
                        disabled={use_city}
                        component={renderField}
                        addClass="form-control w-100"
                        type="text"
                    />
                </div>
                <hr />
                <div className="px-md-5 pt-3 d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <div className="radio">
                        <label className="radio-inline mr-5 d-flex align-items-center">
                            <Field
                                name="is_rental"
                                component={renderFieldCheck}
                                onChange={() => {
                                    this.setState({
                                        is_rental: !this.state.is_rental,
                                    });
                                }}
                            />
                            &nbsp;¿Es alquiler?
                        </label>
                    </div>
                </div>
                <hr />
                <div className="px-md-5 pt-3 d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <div className="radio">
                        <label className="radio-inline mr-5 d-flex flex-row align-items-start">
                            <div className="d-flex flex-column">
                                <Field
                                    name="email"
                                    type="email"
                                    component={renderField}
                                    label={this.props.billingEmail}
                                // input={{value: this.props.billingEmail}}
                                />
                                <p style={{ fontSize: "10px" }}>
                                    La factura se enviará al correo ingresado
                                </p>
                            </div>
                            <div className="mx-4">
                                &nbsp;
                                {this.state.is_rental
                                    ? "Correo del médico al cual se enviará la factura electrónica"
                                    : "Correo del paciente al cual se enviará la factura electrónica"}
                            </div>
                        </label>
                    </div>
                </div>
                {/*
                <div className="row-fluid">
                    <div className="mt-5 d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <button type="button" className="btn btn-secondary" onClick={() => props.changeView('payment')}>Regresar</button>
                        <button type="submit" className="btn btn-primary mx-2">Finalizar Venta</button>
                    </div>
                </div>
                */}
            </form>
        );
    }
}

FrmBillingInformation = reduxForm({
    enableReinitialize: true,
    form: "frmBillingInformation",
    initialValues: {
        option: "a",
        option_direction: "b", //cambiar este cuando ya se pueda obtener la dirección del endpoint
        documento_paciente: "",
        direccion_comprador: "CIUDAD"
    },
    validate: (values) => {
        const errors = {};
        if (!values.direccion_comprador) errors.direccion_comprador = "Campo requerido.";
        if (!values.option) errors.option = "Campo requerido.";
        if (!values.nit) errors.nit = "Campo requerido.";
        if (values.nit && values.nit.toUpperCase() === "CF")
            errors.nit = "Nit Invalido.";
        if (!values.tipo_documento || values.tipo_documento == "" || values.tipo_documento.trim() == "") {
            errors.tipo_documento = "Campo requerido.";
        }
        return errors;
    },
})(FrmBillingInformation);

const selector = formValueSelector("frmBillingInformation");

FrmBillingInformation = connect((state) => {
    const option = selector(state, "option");
    const name = selector(state, "name");
    let show_fields = option === "b" ? true : false;

    const optiond = selector(state, "option_direction");    
    let use_city = optiond === "b" ? true : false;
    
    const nit = selector(state, "nit")
    return {
        show_fields,
        use_city,
        name,
        nit,
    };
})(FrmBillingInformation);

export default FrmBillingInformation;
